<template>
	<div class="nav" v-if="terms.length">
		<div class="container navBox">
			<!-- <router-link
				v-for="(item, index) of terms" :key="index"
				:to="{
					path: '/classify',
					query: {
						id: item.term_id
					}
				}"
				class="navItem"
			>
				{{item.name}}
			</router-link> -->
			<a
				v-for="(item,index) in terms" :key="index"
				class="navItem noSelect"
				:href=" `/classify?term_id=${item.term_id || ''}` "
				@click.prevent="userClick('classify', {
					term_id: item.term_id
				})"
			>
				{{item.name}}
			</a>
		</div>
	</div>
</template>

<script>
	import bus from '../../assets/bus'
	import { mapGetters } from 'vuex'
	export default {
		props:{
			navData:{
				type:Array,
				default:[]
			},
			activeIndex:{
				type:String,
				default:""
			}
		},
		data() {
			return {
				
			}
		},
		computed: {
			...mapGetters([
				// 'logo',
				// 'wxUserInfo',
				'userInfo',
				'terms'
			]),
		},
		mounted() {
			this.getData()
		},
		methods: {
			menuSelect(name,a) {
				
			},
			getData() {
				const p = this.$store.dispatch('getTerms')
				.catch(console.log)
			},
			
			// #Util
			userClick(type, data = {}){
				if(type === 'index') {
					this.$router.push("/")
				}
				else if(type=="my") {
					this.$router.push("/my")
				}
				else if(type=="order") {
					this.$router.push("/order")
				}
				else if(type=="collect") {
					this.$router.push("/collect")
				}
				else if(type === 'address') {
					this.$router.push("/address")
				}
				else if(type === 'logout') {
					this.$store.commit('logout')
				}
				else if(type === 'classify') {
					const path = '/classify'
					this.$router.push({
						path,
						query: {
							// type: 1,
							id: data.term_id
						}
					})
				}
			},
		}
	}
</script>

<style lang="scss">
	.nav {
		// border-bottom: 3px solid $defaultColor;
		border-top: 1px solid #ccc;
		border-bottom: 1px solid #ccc;
		background-color: $color-Page-Bg-02;
		
		.navBox {
			display: flex;
			min-width: $container-MinWidth;
			// justify-content: flex-start;
			justify-content: space-between;
			margin: 0 auto;
			
			.navItem {
				$h: 40px;
				// width: calc($container-MinWidth / $navItem-Num);
				width: 100%;
				height: $h;
				color: #333;
				font-size: 14.5px;
				line-height: $h;
				cursor: pointer;
				text-align: center;
				
				&:hover {
					font-weight: bold;
					text-decoration: underline;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Common/Nav.vue